import { isDefinedError, ORPCError } from '@orpc/client';
import type { TFunction } from 'i18next';

/** User-facing text for any error thrown by the API client (stable codes → i18n). */
export function errorText(t: TFunction, error: unknown): string {
  if (error instanceof ORPCError) {
    if (error.code === 'CONFLICT') {
      const reason = (error.data as { reason?: string } | undefined)?.reason;
      if (reason) {
        const text = t(`conflicts.${reason}` as never, { defaultValue: '' });
        if (text) return text;
      }
    }
    const text = t(`errors.${error.code}` as never, { defaultValue: '' });
    if (text) return text;
    return isDefinedError(error) ? error.message : t('common.unknownError');
  }
  if (error instanceof TypeError) return t('errors.NETWORK');
  return t('common.unknownError');
}

export const isUnauthorized = (e: unknown) => e instanceof ORPCError && e.code === 'UNAUTHORIZED';
export const isPasskeyRequired = (e: unknown) => e instanceof ORPCError && e.code === 'PASSKEY_REQUIRED';
